import { applyUnitsToAll } from "../utils/fonts.js";
import primitives, { sizes, font } from "./primitives.js";
import { tailwind, functional } from "./colors.js";
const themeVariables = {
  color: {
    text: {
      primary: primitives.colors.black[900],
      secondary: primitives.colors.black[700],
      tertiary: primitives.colors.black[600],
      brand: primitives.colors.blaze[600],
      "brand-dark": primitives.colors.blaze[500],
      light: primitives.colors.black[300],
      error: primitives.colors.red[700],
      inverted: primitives.colors.black.white,
      link: primitives.colors.black[900],
      disabled: primitives.colors.black[500],
      "dark-yellow": primitives.colors.yellow[950],
      "dark-green": primitives.colors.green[950],
      "dark-red": primitives.colors.red[950],
      "dark-blue": primitives.colors.blue[950],
      "trend-up": primitives.colors.green[600],
      "trend-down": primitives.colors.red[600]
    },
    surface: {
      primary: primitives.colors.black.white,
      secondary: primitives.colors.black[50],
      tertiary: primitives.colors.black[100],
      brand: primitives.colors.black[950],
      "brand-active": primitives.colors.blaze[950],
      "brand-light": primitives.colors.black[100],
      "brand-medium": primitives.colors.black[400],
      "brand-dark": primitives.colors.black[900],
      "brand-hover": primitives.colors.black[700],
      "error-primary": primitives.colors.red[700],
      "error-secondary": primitives.colors.red[200],
      "error-tertiary": primitives.colors.red[100],
      "warning-primary": primitives.colors.yellow[600],
      "warning-secondary": primitives.colors.yellow[200],
      "warning-tertiary": primitives.colors.yellow[100],
      "info-primary": primitives.colors.blue[700],
      "info-secondary": primitives.colors.blue[200],
      "info-tertiary": primitives.colors.blue[100],
      "success-primary": primitives.colors.green[700],
      "success-secondary": primitives.colors.green[200],
      "success-tertiary": "rgba(240, 246, 238, 1)",
      inverted: primitives.colors.coolGrey[900],
      hover: primitives.colors.blaze[50],
      disabled: primitives.colors.black[100],
      summary: primitives.colors.sand[50]
    },
    border: {
      primary: primitives.colors.black[100],
      secondary: primitives.colors.black[200],
      tertiary: primitives.colors.black[300],
      hover: primitives.colors.black[700],
      focus: primitives.colors.black[800],
      brand: primitives.colors.blaze[600],
      error: primitives.colors.red[600],
      warning: primitives.colors.yellow[600],
      info: primitives.colors.blue[600],
      success: primitives.colors.green[600]
    },
    icon: {
      primary: primitives.colors.black[800],
      secondary: primitives.colors.black[500],
      tertiary: primitives.colors.black[400],
      inverted: primitives.colors.black.white,
      disabled: primitives.colors.black[300],
      inactive: primitives.colors.black[800],
      active: primitives.colors.blaze[600],
      "forest-background": primitives.colors.forest[100],
      "blaze-background": primitives.colors.blaze[100],
      "sand-background": primitives.colors.sand[100],
      "black-background": primitives.colors.black[200],
      "forest-fill": primitives.colors.forest[600],
      "blaze-fill": primitives.colors.blaze[600],
      "sand-fill": primitives.colors.sand[600],
      "black-fill": primitives.colors.black[500]
    },
    button: {
      surface: primitives.colors.black[800],
      border: primitives.colors.black[300],
      hover: primitives.colors.black[900],
      disabled: primitives.colors.black[100],
      pressed: primitives.colors.black[950],
      "primary-surface": primitives.colors.black[800],
      "secondary-surface": primitives.colors.black.white,
      "secondary-border": primitives.colors.black[300],
      "primary-hover": primitives.colors.black[950],
      // "disabled": primitives.colors.opacity[Neutral Darkest 6],
      "secondary-border-disabled": "rgba(19, 18, 16, 0.12)",
      // primitives.colors.black[200],
      "text-hover": "rgba(19, 18, 16, 0.06)",
      "tonal-surface": "rgba(19, 18, 16, 0.06)",
      // "tonal-hover": primitives.colors.opacity[Neutral Darkest 8],
      "text-pressed": "rgba(19, 18, 16, 0.12)",
      "destructive-surface": primitives.colors.red[600],
      "destructive-hover": primitives.colors.red[800],
      "destructive-text": primitives.colors.red[600]
    },
    table: {
      head: {
        background: primitives.colors.black[50],
        text: primitives.colors.black[600],
        border: primitives.colors.black[100]
      },
      body: {
        background: primitives.colors.black.white,
        text: primitives.colors.black[700],
        border: primitives.colors.black[100]
      },
      footer: {
        background: primitives.colors.amber[50],
        text: primitives.colors.black[900]
      }
    },
    /** Raw brand color scales — use these when a semantic token doesn't exist yet */
    brand: {
      blaze: primitives.colors.blaze,
      sand: primitives.colors.sand,
      volt: primitives.colors.volt,
      forest: primitives.colors.forest,
      black: primitives.colors.black
    },
    /** Raw functional color scales (green, red, yellow, blue, teal, coolGrey, warmGrey) */
    functional,
    /** Raw tailwind color scales — all standard tailwind hues */
    tailwind
  },
  sizes: {
    ...sizes,
    spacing: applyUnitsToAll(sizes.spacing),
    radius: applyUnitsToAll(sizes.radius),
    borderWidth: applyUnitsToAll(sizes.borderWidth),
    grid: {
      height: 2.5,
      width: 6
    },
    table: {
      headerHeight: sizes.spacing["11"]
      // 3rem
    }
  },
  fonts: {
    ...font,
    letterSpacing: applyUnitsToAll(font.letterSpacing),
    lineHeight: applyUnitsToAll(font.lineHeight),
    size: applyUnitsToAll(font.size)
  },
  typography: {
    fontFamily: ["Archivo", "sans-serif"].join(", "),
    fontWeightLight: primitives.font.weight.light,
    fontWeightRegular: primitives.font.weight.normal,
    fontWeightMedium: primitives.font.weight.medium,
    fontWeightBold: primitives.font.weight.bold
  }
};
export {
  themeVariables
};
